<!-- 发起咨询 -->
<template>
  <div>
    <el-dialog
      title="发起咨询"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      v-el-drag-dialog
      @close="changeClose"
    >
      <el-form :model="form" label-width="100px" ref="form" v-loading="loading">
        <el-form-item label="咨询内容:" prop="content">
          <el-input
            v-model="form.content"
            placeholder="请输入要咨询的内容"
            type="textarea"
            :autosize="{ minRows: 5}"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传文件:" prop="files">
          <upload-file :list.sync="form.files" ref="uploadFile"></upload-file>
        </el-form-item>
        <div class="flex-row-center">
          <div class="box-btn" style="width: 290px" @click="submit">
            立即咨询
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import UploadFile from '@/components/Common/UploadFile'

export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      id: '', // 工单id
      form: {
        content: '',
        files: []
      }
    }
  },
  components: {
    UploadFile
  },
  computed: {},
  mounted() {},
  methods: {
    open(data) {
      this.id = data.sheetId
      this.dialogVisible = true
    },

    submit() {
      if (!this.form.content) {
        this.$notify.error({
          title: '提示',
          message: '请输入咨询内容'
        })
        return
      }
      this.loading = true
      this.$api.order
        .sheetReplayManager({
          sheetId: this.id,
          ...this.form
        })
        .then(({ data }) => {
          this.loading = false
          if (data.code == 200) {
            this.dialogVisible = false
            this.$notify.success({
              title: '提示',
              message: '咨询成功'
            })
            this.$emit('refresh')
          }
        }).catch(() => { this.loading = false })
    },

    changeClose() {
      this.form = {
        content: '',
        files: []
      }
      this.$refs.uploadFile.clearFiles()
    }
  }
}
</script>

<style lang='scss' scoped>
</style>
